import axios from 'axios'
import { decode } from 'jsog'

const toData = response => decode(response.data)

export function getUnits(): Promise {
  return axios.get('/bw/organizationalunit/').then(toData)
}

export function exportOrganunits(): Promise {
  return axios.get('bw/organizationalunit/export', {
    headers: {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'arraybuffer'
  })
}

export function importUnits(data): Promise {
  return axios.post(`bw/organizationalunit/import`, data).then(toData)
}

export function deleteUnit(id): Promise {
  return axios.delete(`bw/organizationalunit/${id}`)
}

export function upsertUnit(data): Promise {
  return axios.post(`bw/organizationalunit/`, data)
}


export function getUnitsByLocation(id): Promise {
  return axios.get(`/bw/organizationalunit/location/${id}`).then(toData)
}

export function getUnitById(id): Promise {
  return axios.get(`/bw/organizationalunit/${id}`).then(toData)
}

export function getUnitsWithScores(): Promise {
  return axios.get(`/bw/organizationalunit/withscores`).then(toData)
}





// WEBPACK FOOTER //
// ./src/services/organizational-units-service.js